import { featureFlagHandlers } from './feature-flag';

export const handlers = [...featureFlagHandlers];
